import $ from 'jquery'
import globalEventBus from 'toxilibs/event_bus_queued.js'

// TODO - Migrate other buttons here

globalEventBus.on('menu hidden', hideButtons)

globalEventBus.on('menu displayed', showButtons)


let fadeDelay = 500

function hideButtons () {
    $('button.about').fadeOut(fadeDelay)
}


function showButtons () {
    $('button.about').fadeIn(fadeDelay)
}


